<ng-container *ngIf="items$ | async as items">
  <div *ngIf="items.length" class="column cart-item">
    <div *ngFor="let item of items; trackBy: identify">
      <div class="d-flex flex-row mx-0">
        <img
          alt=""
          class="rounded cursor-pointer"
          src="{{ item.productData.ItemImageURL | contentImage: '6' }}"
          (click)="redirectToDetail(item.productData.Id)"
        />
        <div class="flex-column w-100 ms-3 position-relative">
          <div class="d-flex flex-row justify-content-between text-start">
            <p class="font-size-14 fw-bold mb-1 cursor-pointer" (click)="redirectToDetail(item.productData.Id)">
              {{ item.productData.DisplayName }}
            </p>
          </div>
          <div *ngIf="item.attributes" class="d-flex flex-row mb-1">
            <!-- For each selected attributes-->
            <div
              *ngFor="let attribute of item.attributes.LocalAttributes"
              class="text-start font-size-12 ps-0 text-nowrap mb-0 me-4"
            >
              <span class="fw-bold">{{ attribute.AttributeName }}: </span> {{ attribute.ValueName }}
            </div>
          </div>
          <div *ngIf="item.customFields" class="d-flex flex-row flex-wrap mb-1">
            <!-- For each custom Field-->
            <div *ngFor="let customField of item.customFields">
              <div *ngIf="customField.customFieldValue" class="text-start font-size-12 ps-0 me-4 mb-0">
                <span class="fw-bold">{{ customField.customFieldName }}: </span> {{ customField.customFieldValue }}
              </div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <div class="d-flex align-items-center flex-row w-100">
              <div class="text-start font-size-12 ps-0 text-nowrap align-items-center d-flex">
                <ng-container *ngIf="isCheckoutPage; else canNotChangeQuantity">
                  <p class="mb-0 me-1 fw-bold">{{ 'cart.quantity' | translate }}</p>
                  <p class="mb-0">{{ item.purchaseQuantity }}</p>
                </ng-container>
                <ng-template #canNotChangeQuantity>
                  {{ item.purchaseQuantity }}
                </ng-template>
              </div>
              <div class="text-start font-size-12 text-nowrap col-6 ms-5">
                <ng-container *ngIf="!item.productData.MerchantValue">
                  <span class="fw-bold pe-2 cart-points-label">{{ 'cart.points' | translate }} </span>
                  <span class="cart-points"> {{ item.purchaseQuantity * item.productData.PointValue | number }}</span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="font-size-12 mt-2 text-danger">
        {{ checkQuantityOfCartItem(item) | translate : { marketplaceItemCount: marketplaceItemCount } }}
      </div> -->
    </div>
  </div>
  <div *ngIf="!items.length" class="font-size-14">
    <p>{{ 'cart.empty.basket' | translate }}</p>
  </div>
</ng-container>
